export const BASE_URL = 'https://jsonplaceholder.typicode.com';

export const PER_PAGE = 10;
